const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const ENVIRONMENT_ID = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT_ID
  || 'master';
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

const prodEnv = process.env.REACT_APP_NAME === 'Prod';
const BASE_URL = prodEnv
  ? 'https://cdn.contentful.com'
  : 'https://preview.contentful.com';

/**
 * Fetches entries directly from Contentful. `query` accepts any Contentful
 * search parameter, e.g. `{ 'fields.operatingSystem': 'Web' }`.
 *
 * We use `prod -> published status` and
 * `non-prod -> draft status`, instead of using a
 * dedicated Contentful environment.
 */
export const getContentfulEntries = async ({ contentType, query = {} }) => {
  try {
    // in prod env only appears published entries
    // in non-prod env appears both published and draft entries
    const draftOnlyFilter = prodEnv
      ? {} : { 'sys.publishedAt[exists]': false };

    const params = new URLSearchParams({
      content_type: contentType,
      ...query,
      ...draftOnlyFilter,
    });
    const url = `${BASE_URL}/spaces/${SPACE_ID}/environments/`
      + `${ENVIRONMENT_ID}/entries?${params.toString()}`;

    const request = await fetch(url, {
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    });
    const response = request.ok ? await request.json() : null;

    return {
      data: response,
      devError: '',
      ok: request.ok,
      status: request.status,
    };
  } catch (_) {
    return {
      data: null,
      devError: _.message,
      ok: false,
      status: 500,
    };
  }
};
